const types = {
    API_SET_IS_ONLINE: 'API_SET_IS_ONLINE',
    API_SET_IS_SERVER_OK: 'API_SET_IS_SERVER_ERROR',
    API_SET_USER_RESPONSE_QUEUE: 'API_SET_USER_RESPONSE_QUEUE',
    API_SET_USER_RESPONSE_QUEUE_AND_PENDING_REQUEST: 'API_SET_USER_RESPONSE_QUEUE_AND_PENDING_REQUEST',
    API_SET_USER_RESPONSE_QUEUE_STATUS: 'API_SET_USER_RESPONSE_QUEUE_STATUS',
    API_SET_STATE: 'API_SET_STATE',
    API_SET_CONNECTION_STATUS: 'API_SET_CONNECTION_STATUS',
    API_SET_PRELOADING_STATUS: 'API_SET_PRELOADING_STATUS',
    API_SET_SERVER_ERROR_START_TIME: 'API_SET_SERVER_ERROR_START_TIME',
    API_REMOVE_PENDING_RESPONSE_REQUEST: 'API_REMOVE_PENDING_RESPONSE_REQUEST',
};

const apiActions = {
    types,

    setIsOnline(isOnline) {
        if (typeof isOnline === 'boolean') {
            return { type: types.API_SET_IS_ONLINE, isOnline };
        }
        throw new Error('Non boolean passed to setIsOnline().');
    },

    setIsServerOK(isServerOK) {
        if (typeof isServerOK === 'boolean') {
            return { type: types.API_SET_IS_SERVER_OK, isServerOK };
        }
        throw new Error('Non boolean passed to setIsServerError().');
    },

    setUserResponseQueue(queue) {
        if (queue instanceof Array) {
            return { type: types.API_SET_USER_RESPONSE_QUEUE, queue };
        }
        throw new Error('Non array passed to updateUserResponseQueue().');
    },

    setUserResponseQueueWithPendingRequest(queue, requestId) {
        if ((queue instanceof Array) && typeof requestId === 'string') {
            return { type: types.API_SET_USER_RESPONSE_QUEUE_AND_PENDING_REQUEST, queue, requestId };
        }
        throw new Error('Wrong parameters passed to setUserResponseQueueWithPendingRequest().');
    },

    removePendingResponseRequest(requestId) {
        return { type: types.API_REMOVE_PENDING_RESPONSE_REQUEST, requestId };
    },

    setUserResponseQueueStatus(lastResult, lastDateTime) {
        return { type: types.API_SET_USER_RESPONSE_QUEUE_STATUS, lastResult, lastDateTime };
    },

    setApiConnectionStatus(status) {
        return { type: types.API_SET_CONNECTION_STATUS, status };
    },

    setPreloadingStatus(isPreloading) {
        return { type: types.API_SET_PRELOADING_STATUS, isPreloading };
    },

    setServerErrorStartTimestamp(time) {
        return { type: types.API_SET_SERVER_ERROR_START_TIME, time };
    },
};

export default apiActions;
